<template>
    <d-contract-edit
        v-model      = "edit"
        title        = "ZÜS"
        :type-id     = "typeId"
        :contract-id = "contractId"
        :company-id  = "companyId"
        @initialized = "onInitialized"
        @saved       = "onSaved"
    >
        <!--
        <template v-slot:terms>
            <c-column-header
                class  = "primary mt-0"
                :label = "$t('contract.terms') "
            />

            <div class="lm-border pa-3 pt-0 mt-1">
                <c-contract-zus-terms
                    :contract   = "contract"
                    :readonly   = "false"
                    :show-title = "false"
                    class       = "pt-2"
                    style       = "height: 694px"
                />
            </div>
        </template>
        -->
    </d-contract-edit>
</template>

<script>

import Core              from "@/modules/core/service/Core";
import Contract          from "@/modules/msd/company/contract/service/Contract";
import DContractEdit     from "@/modules/msd/company/contract/components/controls/DContractEdit";
//import CContractZusTerms from "@/modules/msd/company/contract/components/controls/zus/CContractZusTerms";
//import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";

export default {
    name: "DContractZusEdit",

    components: {
      // CColumnHeader,
      //  CContractZusTerms,
        DContractEdit,
    },

    props: {
        value: {

        },

        contractId: {
            required: false,
            type    : Number,
            default : function () {
                return null
            }
        },

        companyId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },
    },

    data: () => ({
        edit: false,
        contract: null,
    }),

    watch: {
        value () {
            this.edit = this.value;
        },

        edit () {
            if (!this.edit)
                this.$emit("input", this.edit);
        }
    },

    computed: {
        typeId () {
            return Contract.enums.types.zus;
        }
    },

    methods: {
        onInitialized (contract) {
            this.contract = contract;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        }
    }
}
</script>
